<template>

  <el-form :model="form" :rules="rules" ref="form">

    <el-form-item label="Nome Completo" prop="nome">
      <em>Nome do sócio administrador, empresário ou representante legal</em>
      <el-input v-model="form.nome" placeholder="Nome Completo"></el-input>
    </el-form-item>

    <el-form-item label="Email" prop="email">
      <el-input v-model="form.email" placeholder="Email"></el-input>
    </el-form-item>

    <el-form-item label="Telefone Fixo" prop="telefone">
      <div class="el-input">
        <input type="text" v-model="form.telefone" placeholder="(99) 9999-9999"  v-mask="'(99) 9999-9999'" class="el-input__inner" />
      </div>
    </el-form-item>

    <el-form-item label="Celular" prop="celular">
      <div class="el-input">
        <input type="text" v-model="form.celular" placeholder="(99) 99999-9999"  v-mask="'(99) 99999-9999'" class="el-input__inner" />
      </div>
    </el-form-item>

    <el-form-item label="CPF" prop="cpf">
      <em>CPF do sócio administrador da empresa ou solicitante</em>
      <div class="el-input">
        <input type="text" v-model="form.cpf" placeholder="999.999.999-99" v-mask="'999.999.999-99'" class="el-input__inner" />
      </div>
    </el-form-item>

  </el-form>

</template>

<script>
import AwesomeMask from 'awesome-mask'
import { validaCpf } from '../../validators/cpf.js'

export default {
  props: ['form'],

  directives: {
    'mask': AwesomeMask
  },

  data () {
    return {
      rules: {
        nome: [
          { required: true, message: 'O nome é obrigatório', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'O email é obrigatório', trigger: 'blur' },
          { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }
        ],
        telefone: [
          { type: 'string', pattern: /\((10)|([1-9][1-9])\) [0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto: Ex. (99) 9999-9999', trigger: 'blur' }
        ],
        celular: [
          { required: true, message: 'Um número de celular é obrigatório', trigger: 'blur' },
          { type: 'string', pattern: /\((10)|([1-9][1-9])\) [9][0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um celular no formato correto: Ex. (99) 99999-9999', trigger: 'blur' }
        ],
        cpf: [
          { required: true, message: 'O CPF é obrigatório', trigger: 'blur' },
          { validator: validaCpf, trigger: 'blur' }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Solicitante.vue?1e1a8c8c